module.exports = __webpack_public_path__ + "img/loading.66168b82.gif";